if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (document.querySelector('.upsell-is-active')) {
        this.submitButton = document.querySelector('.upsell-is-active');
      }
      else {
        this.submitButton = this.querySelector('[type="submit"]');
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      delete config.headers['Accept'];

      const formData = new FormData(this.form);

      const object = {};
      formData.forEach(function (value, key) {
        if (key === 'quantity' || key === 'id') {
          object[key] = parseInt(value);
        } else {
          object[key] = value;
        }
      });
      const formDataUpdate = {
        items: [object]
      };

      // Add product rebuy upsells to cart
      if (document.querySelectorAll('.product-rebuy').length > 0) {
        document.querySelectorAll('.product-rebuy').forEach((input) => {
          if (input.checked) {
            const itemObject = {
              quantity: 1,
              id: input.id
            };
            formDataUpdate.items.push(itemObject)
          }
        });
      };

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);

        formDataUpdate['sections'] = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        formDataUpdate['sections_url'] = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = JSON.stringify(formDataUpdate);

      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // Refresh Rebuy product list
          rebuy_recommended();
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (document.querySelector('.product-rebuy-submit')) document.querySelector('.product-rebuy-submit').classList.remove('upsell-is-active')
          this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class rebuyWidget extends HTMLElement {
  constructor() {
    super();
    this.targetElement = this.querySelector('.product-rebuy-content');
    this.template = this.querySelector('template');
    this.submitButton = this.querySelector('.product-rebuy-submit');
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.renderProducts();
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
  renderProducts() {
    const requestParameters = new URLSearchParams({
      shopify_product_ids: this.dataset.ids,
      limit: this.dataset.limit,
      key: "5b81a3fb05d63ee9ceb7fa196b14fc2c6f45ce90"
    });

    fetch(this.dataset.url + requestParameters)
      .then(response => response.json())
      .then(data => {
        const templateHtml = this.template.innerHTML;
        const result = Mustache.render(templateHtml, data.data);
        this.targetElement.innerHTML += result;
        if (data.data.length === 0) {
          this.style.display = 'none';
        } else {
          this.style.visibility = 'visible';
        }
        this.eventHandlers();
      })
      .catch(e => {
        console.error(e);
      });
  }
  eventHandlers() {
    this.inputs = this.querySelectorAll('.product-rebuy');
    this.inputs.forEach((input) => {
      input.addEventListener('change', (event) => {
        this.priceAndItemsSubmitUpdate(this.inputs);
      });
    });

    this.submitButton.addEventListener('click', (event) => {
      this.submitButton.classList.add('upsell-is-active');
      document.querySelector('.product-form__submit').click();
    });
  }
  priceAndItemsSubmitUpdate(inputs) {
    let items = [{
      id: this.dataset.product,
      quantity: 1
    }];
    let totalPrice = parseInt(this.querySelector('#product-rebuy-total').dataset.price);
    inputs.forEach((input) => {
      input.checked == true && (totalPrice += (parseFloat(input.dataset.price) * 100));
      if (input.checked) {
        let item = {
          id: input.id,
          quantity: 1,
        };
        items.push(item)
      }
    });

    // Update the total price in the widget footer
    this.querySelector('#product-rebuy-total').textContent = Shopify.formatMoney(totalPrice);
  }
}

customElements.define('rebuy-widget', rebuyWidget);